<template>
    <div class="header row">
        <div v-if="!$store.state.hideLogo" class="col col-md-2 col-lg-2 col-sm-12 col-xs-12 logo">
            <img v-if="$store.state.theme === 'dark-theme'" :src="`/analiz/img/${$store.state.template}-dark.svg`" :alt="labelDefinition.appLogo[$store.state.lang]" />
            <img v-if="$store.state.theme === 'light-theme'" :src="`/analiz/img/${$store.state.template}-light.svg`" :alt="labelDefinition.appLogo[$store.state.lang]" />
        </div>
        <div class="col col-auto" v-if="!$store.state.hideLogo">
            <div class="main-title">{{ projectTitle }}</div>
        </div>
        <div v-if="date" class="col date-area">
            <div class="controls-row">
                <div class="control-group">
                    <div class="header-right-label">{{ labelDefinition.currency[$store.state.lang] }}</div>
                    <MultipleSelection 
                        :items="currencyItems" 
                        :selected-value="currency" 
                        @change="selectFilter(adjusted, $event)"
                        :item-width="50"
                        :group-label="labelDefinition.currency[$store.state.lang]"
                        :lang="$store.state.lang"
                    />
                </div>
                <div class="control-group" v-if="!isUnadjustedSymbol">
                    <div class="header-right-label">
                        {{ labelDefinition.adjusted[$store.state.lang] }}
                        <v-tooltip top v-if="currency != 'TRY'">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>{{ labelDefinition.unadjustedInfo[$store.state.lang] }}</span>
                        </v-tooltip>
                    </div>
                    <MultipleSelection 
                        :items="adjustedItems" 
                        :selected-value="adjusted" 
                        @change="selectFilter($event, currency)"
                        :item-width="40"
                        :group-label="labelDefinition.adjusted[$store.state.lang]"
                        :lang="$store.state.lang"
                    />
                </div>
                <div class="control-group">
                    <div class="header-right-label text-align-right">{{ date }}</div>
                    <div class="right-controls">
                        <MultipleSelection 
                            :items="languageItems" 
                            :selected-value="$store.state.lang" 
                            @change="selectLanguage"
                            :item-width="30"
                            :group-label="labelDefinition.language[$store.state.lang]"
                            :lang="$store.state.lang"
                        />
                        <button
                            type="button"
                            class="theme-icon"
                            :aria-label="labelDefinition.themeToggle[$store.state.lang]"
                            @click="setTheme()"
                        >
                            <img v-if="$store.state.theme === 'light-theme'" src="/analiz/img/dark-theme-icon.png" alt="" aria-hidden="true"/>
                            <img v-if="$store.state.theme === 'dark-theme'" src="/analiz/img/light-theme-icon.png" alt="" aria-hidden="true"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import definition from '../data-definition';
import MultipleSelection from './MultipleSelection.vue';

export default {
    name: 'DashboardHeader',
    components: {
        MultipleSelection
    },
    props: {
        date: String,
        isUnadjustedSymbol: Boolean
    },
    data() {
        return {
            labelDefinition: definition.labelDefinition,
            adjusted: true,
            currency: 'TRY'
        }
    },
    computed: {
        projectTitle() {
            const title = this.labelDefinition.projectTitle[this.$store.state.lang];
            return this.$commonHelper.toLocaleUpperCase(title);
        },
        languageItems() {
            return [
                { value: 'tr', label: 'TR' },
                { value: 'en', label: 'EN' }
            ];
        },
        currencyItems() {
            return [
                { value: 'TRY', label: 'TL' },
                { value: 'USD', label: 'USD' },
                { value: 'EUR', label: 'EUR' }
            ];
        },
        adjustedItems() {
            return [
                { value: true, label: this.labelDefinition.adjustedYes[this.$store.state.lang], disabled: this.currency != 'TRY' },
                { value: false, label: this.labelDefinition.adjustedNo[this.$store.state.lang] }
            ];
        }
    },
    methods: {
        selectLanguage(lang) {
            this.$store.commit('set', ['lang', lang]);
            this.$emit('language-changed', lang)
        },
        selectFilter(adjusted, currency) {
            if (this.currency != currency && currency === 'TRY') {
                this.adjusted = true;
                this.currency = currency;
            } else if (this.currency != currency && currency != 'TRY' && this.adjusted) {
                this.adjusted = false;
                this.currency = currency;
            } else if (this.adjusted != adjusted && currency != 'TRY' && !this.adjusted) {
                this.currency = 'TRY';
                this.adjusted = adjusted;
            } else {
                this.adjusted = adjusted;
                this.currency = currency;
            }

            this.$emit('filter-changed', this.adjusted, this.currency);
        },
        setTheme() {
            const theme = this.$store.state.theme === 'dark-theme' ? 'light-theme' : 'dark-theme';
            this.$store.commit('set', ['theme', theme]);
        }
    }
}
</script>
<style scoped>
@media only screen and (min-width: 768px) {
  .header {
    padding-top: 1rem;
  }
}

.logo {
    padding-top: 0.7rem !important;
    min-width: 220px;
}

.logo img {
    width: 12rem;
    display: flex;
    margin: 0 auto;
    margin-top: 5px;
}

.date-area {
    text-align: right;
}

.controls-row {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    justify-content: flex-end;
}

.control-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.right-controls {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

.theme-icon {
    cursor: pointer;
    background-color: var(--right-info-color);
    padding: 2px 4px;
    border-radius: 4px;
    border: none;
    line-height: 0;
}

.theme-icon img {
    height: 16px;
    width: 16px;
}

.spacer {
    margin-left: 10px;
}

</style>